module.exports = __webpack_public_path__ + "img/marmelaedchen-korb_xs.b51df6ac.jpg";